import { c as _c } from "react/compiler-runtime";
import { Button } from "@flat-ui";
/**
 * Ghost button used in the rows of the subscription settings page to open
 * a dialog with the details behind a usage metric or a software license.
 */
export function ViewDetailsButton(t0) {
  const $ = _c(4);
  const {
    label,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      padding: "8px 16px",
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: "18px",
      gap: "8px",
      "&:hover": {
        borderRadius: "4px",
        backgroundColor: "action.hover"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label || $[2] !== onClick) {
    t2 = <Button variant="ghost" size="m" onClick={onClick} sx={t1}>{label}</Button>;
    $[1] = label;
    $[2] = onClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}